import taskService from '../../../services/TaskService';
import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import { Button, CircularProgress, Grid } from '@material-ui/core';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';

const taskNotificationPreferenceOptions = [
  { value: 'Whatsapp', label: 'Whatsapp' },
  { value: 'Text Message', label: 'Text Message' },
  { value: 'Email', label: 'Email' }
];

const TaskNotificationPreference = () => {
  const [preferenceExists, setPreferenceExists] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting }
  } = useForm({
    defaultValues: { notificationPreference: [] }
  });

  useEffect(() => {
    const fetchEmployeeTaskNotificationPreference = async () => {
      try {
        const response = await taskService.getMyNotificationPreference();
        const preference = response?.data?.data;
        setPreferenceExists(Boolean(preference));
        reset({ notificationPreference: preference?.notificationPreference || [] });
      } catch (error) {
        toast.error(error?.response?.data?.message || 'Could not get task notification preferences.');
      } finally {
        setLoading(false);
      }
    };
    fetchEmployeeTaskNotificationPreference();
  }, [reset]);

  const onSubmit = async ({ notificationPreference }) => {
    try {
      const response = preferenceExists
        ? await taskService.updateTaskNotificationPreference(notificationPreference)
        : await taskService.createTaskNotificationPreference(notificationPreference);
      const preference = response?.data?.data;
      setPreferenceExists(true);
      reset({ notificationPreference: preference?.notificationPreference || notificationPreference });
      toast.success('Task notification preferences saved.');
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Could not save task notification preferences.');
    }
  };

  if (isLoading) {
    return (
      <div style={{ width: '100%', textAlign: 'center', padding: '1.5rem' }}>
        <CircularProgress size={24} />
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <p>Select how you want to be notified about tasks.</p>
          <Controller
            name="notificationPreference"
            control={control}
            render={({ field }) => (
              <ReactSelect
                inputId="task-notification-preference"
                className="basic-multi-select"
                classNamePrefix="select"
                value={taskNotificationPreferenceOptions.filter((option) => (field.value || []).includes(option.value))}
                isMulti
                isSearchable
                isClearable
                isDisabled={isSubmitting}
                // eslint-disable-next-line no-undef
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                options={taskNotificationPreferenceOptions}
                onBlur={field.onBlur}
                onChange={(selected) => field.onChange((selected || []).map((option) => option.value))}
              />
            )}
          />
          <p className="tw-text-xs tw-mt-3 tw-mb-0 tw-text-[#666]">
            *** Critical tasks are always sent by WhatsApp, text message and email. ***
          </p>
        </Grid>
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
          <Button type="submit" variant="outlined" color="primary" disabled={isSubmitting}>
            {isSubmitting ? <CircularProgress size={20} /> : 'Save preferences'}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default TaskNotificationPreference;
